function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import UnstyledButton from './UnstyledButton';
const SwitchButton = _ref => {
  let {
    active,
    activeBg,
    bg,
    knobBg,
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(UnstyledButton, _extends({
    sx: {
      outline: 0,
      display: 'inline-block',
      width: size === 'small' ? '48px' : size === 'tiny' ? '32px' : '64px',
      height: size === 'small' ? '24px' : size === 'tiny' ? '16px' : '32px',
      borderRadius: size === 'small' ? '24px' : size === 'tiny' ? '16px' : '32px',
      position: 'relative',
      cursor: 'pointer',
      userSelect: 'none',
      bg: active ? activeBg : bg,
      padding: '2px',
      transition: 'all .4s ease',
      '&:after': {
        position: 'relative',
        content: '""',
        width: '50%',
        height: '100%',
        display: 'block',
        left: active ? '50%' : 0,
        borderRadius: '50%',
        bg: knobBg,
        transition: 'all .2s ease'
      },
      '&::selection': {
        background: 'none'
      }
    }
  }, props));
};
SwitchButton.propTypes = {};
SwitchButton.defaultProps = {
  active: false,
  activeBg: 'secondary',
  bg: 'gray.3',
  knobBg: 'white',
  size: 'default'
};
SwitchButton.displayName = 'SwitchButton';
export default SwitchButton;